import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models/ValuableNode'

export class SchemaBigIntNode extends ValuableNode {
  @fromSpecific()
  @reactive()
  maximum?: bigint | number

  @fromSpecific()
  @reactive()
  minimum?: bigint | number
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.BigInt': SchemaBigIntNode
  }
}
